import React, { FC, PropsWithChildren, createContext, useMemo, useState, useCallback } from 'react'

export type ISnackbarSeverity = 'error' | 'warning' | 'info' | 'success'

export interface ISnackbarData {
  message: string,
  severity: ISnackbarSeverity,
  color: string,
}

export interface ISnackbarContext {
  snackbar?: ISnackbarData,
  setSnackbar: {
    (message?: string | null, severity?: ISnackbarSeverity): void,
  },
}

export const SNACKBAR_SEVERITY_COLORS: Record<ISnackbarSeverity, string> = {
  error: '#990000',
  warning: '#CCCC00',
  info: '#000099',
  success: '#009900',
}

export const SnackbarContext = createContext<ISnackbarContext>({
  setSnackbar: () => {},
})

export const useSnackbarContext = (): ISnackbarContext => {
  const [ snackbar, setRawSnackbar ] = useState<ISnackbarData>()
  const setSnackbar = useCallback((message?: string | null, severity?: ISnackbarSeverity) => {
    if(!message) {
      setRawSnackbar(undefined)
    } else {
      const useSeverity = severity || 'info'
      const color = SNACKBAR_SEVERITY_COLORS[useSeverity]
      setRawSnackbar({
        message,
        severity: useSeverity,
        color,
      })
    }
    
  }, [])
  const contextValue = useMemo<ISnackbarContext>(() => ({
    snackbar,
    setSnackbar,
  }), [
    snackbar,
    setSnackbar,
  ])
  return contextValue
}

export const SnackbarContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const value = useSnackbarContext()
  return (
    <SnackbarContext.Provider value={ value }>
      { children }
    </SnackbarContext.Provider>
  )
}